export default "__VITE_ASSET___O$8bHpi__ 1570w, __VITE_ASSET__zTqCqLNe__ 1000w, __VITE_ASSET__0$3R2OSl__ 500w";